import type { FeatureAccessSettingsClients } from '@ms/yammer-graphql';

import type { FeatureAccessSettings } from '../../state/types';

import { coalesceToFallback } from './strategies/nullable';

type FeatureAccessSettingsNormalizer = (response: {
  readonly data: FeatureAccessSettingsClients;
}) => FeatureAccessSettings;

export const normalizeFeatureAccessSettings: FeatureAccessSettingsNormalizer = (response) => ({
  canUseDelegateTeamsOnStoryline: response.data.settings.storyline.canUseDelegateTeamsOnStoryline,
  viewerCanAccessStories: response.data.settings.stories.viewerCanAccessStories,
  viewerCanAccessStoryline: response.data.settings.storyline.viewerCanAccessStoryline,
  viewerCanHideThreadsForNetworkInDiscovery:
    response.data.settings.adminSettings.viewerCanHideThreadsForNetworkInDiscovery,
  viewerCanPostToStoryline: !!response.data.viewer.user.wallFeed?.viewerCanStartThread,
  viewerCanPostStorylineAnnouncement: response.data.settings.storyline.viewerCanPostStorylineAnnouncement,
  viewerCanAccessLeadershipCorner: response.data.settings.leader.viewerCanAccessLeadershipCorner,
  viewerIsLeader: response.data.viewer.user.isLeader,
  viewerHasNetworkWideAudience: response.data.viewer.user.hasNetworkWideAudience,
  viewerHasMultiTenantWideAudience: coalesceToFallback(response.data.viewer.user?.hasMultiTenantWideAudience, false),
  viewerCanAccessThreadExtendedActivity: response.data.viewer.canViewThreadExtendedActivity,
  viewerCanAccessLeaderManagement: response.data.viewer.canAccessLeaderManagement,
  viewerCanDesignateLeaders: response.data.viewer.canDesignateLeaders,
  viewerCanCreateCampaigns: response.data.settings.campaigns.viewerCanCreateCampaigns,
  viewerCanAccessCampaignsRecommendations: response.data.settings.campaigns.viewerCanAccessCampaignsRecommendations,
  viewerCanAccessCampaignsDashboard: response.data.settings.campaigns.viewerCanAccessCampaignsDashboard,
  viewerCanAccessCampaignActivity: response.data.settings.campaigns.viewerCanAccessCampaignActivity,
  viewerCanScheduleDraftPosts: response.data.settings.network.viewerCanScheduleDraftPosts,
  viewerCanCreateMultiLanguageMessage: response.data.settings.network.viewerCanCreateMultiLanguageMessage,
  viewerCanCurateTopic: response.data.settings.networkQuestion.viewerCanCurateTopic,
  viewerCanRemoveTopic: response.data.settings.networkQuestion.viewerCanRemoveTopic,
  viewerCanAccessNetworkLevelInsights: response.data.settings.networkQuestion.viewerCanAccessNetworkLevelInsights,
  isGroupQuestionsAIImporterEnabled: response.data.settings.networkQuestion.isGroupQuestionsAIImporterEnabled,
  isNetworkQuestionsAIFeaturesEnabled: response.data.settings.networkQuestion.isNetworkQuestionsAIFeaturesEnabled,
  isNetworkQuestionsAIImporterEnabled: response.data.settings.networkQuestion.isNetworkQuestionsAIImporterEnabled,
  isPrivateContentModeActiveForViewer: response.data.settings.adminSettings.isPrivateContentModeActiveForViewer,
  viewerCanAccessNetworkQuestions: response.data.settings.networkQuestion.viewerCanAccessNetworkQuestions,
  networkQuestionsEnablementMode: response.data.settings.networkQuestion.networkQuestionsEnablementMode,
  viewerCanPromoteConversationInStoryline: response.data.settings.storyline.viewerCanPromoteConversationInStoryline,
  viewerCanPromoteConversationInGroup: response.data.settings.group.viewerCanPromoteConversations,
  viewerAllowedUserAdminRoleAssignments: response.data.settings.adminRoles.viewerAllowedUserAdminRoleAssignments,
  viewerCanAssignUserAdminRoles: response.data.settings.adminRoles.viewerCanAssignUserAdminRoles,
  viewerCanAccessCopilot: response.data.settings.copilot.viewerCanAccessCopilot,
  viewerCanAccessM365Copilot: response.data.settings.copilot.viewerCanAccessM365Copilot,
  viewerCanCreateArticle: response.data.settings.article.viewerCanCreateArticle,
  viewerHasMobileClient: response.data.viewer.hasMobileClient,
  viewerCanAccessCommsDashboard: response.data.viewer.canAccessDashboard,
});
